module.exports = __webpack_public_path__ + "static/media/remove.3eca0e6e.svg";